import type { RouteRecordRaw } from 'vue-router'
import { requirementRouteCandidates, toAnyPermission } from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createRequirementChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: '',
    ...maybeRouteName(withNames, 'requirements'),
    component: () => import('@/views/requirement/RequirementList.vue'),
    meta: { permission: 'requirement:record:view' }
  },
  {
    path: 'tasks',
    ...maybeRouteName(withNames, 'requirement-tasks'),
    component: () => import('@/views/requirement/RequirementTaskList.vue'),
    meta: { permission: 'requirement:record:view' }
  },
  {
    path: 'bugs',
    ...maybeRouteName(withNames, 'requirement-bugs'),
    component: () => import('@/views/requirement/RequirementBugList.vue'),
    meta: { permission: 'requirement:bug:view' }
  },
  {
    path: 'iterations',
    ...maybeRouteName(withNames, 'requirement-iterations'),
    component: () => import('@/views/requirement/RequirementIterationList.vue'),
    meta: { permission: 'requirement:iteration:view' }
  },
  {
    path: 'analytics',
    ...maybeRouteName(withNames, 'requirement-analytics'),
    component: () => import('@/views/requirement/RequirementAnalytics.vue'),
    meta: { permission: 'requirement:analytics:view' }
  },

  {
    path: ':id',
    ...maybeRouteName(withNames, 'requirement-detail'),
    component: () => import('@/views/requirement/RequirementDetail.vue'),
    meta: { permission: 'requirement:record:view' }
  }
]

const createRequirementRoute = (path: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/requirement/RequirementLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(requirementRouteCandidates),
    defaultRouteBasePath: withNames ? '/t/:tenantCode/requirements' : '/requirements',
    defaultRouteCandidates: requirementRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createRequirementChildren(withNames)
})

const requirementRoutes: RouteRecordRaw[] = [
  createRequirementRoute('t/:tenantCode/requirements', true),
  createRequirementRoute('requirements', false),
]

export default requirementRoutes
